export default __webpack_public_path__ + "static/pic_release-999cee135f5b5a540ba49c474605cb9d.svg";